<template>
    <b-card>
        <b-card-header>Skapa simuleringsskript från MsgRefIds</b-card-header>
        <b-card-body>
            <b-row>
                <b-col>
                    <b-textarea autofocus v-model="searchFor" rows="10" placeholder="Ange MsgRefIds..."></b-textarea>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    <b-button @click="generate()">Skapa skript</b-button>
                </b-col>
                <b-col cols="3" v-if="max>0">
                    <b-progress :value="scriptItems.length" :max="max" show-progress animated></b-progress>
                    {{ progress }}
                </b-col>

            </b-row>
            <b-row>
                <b-col>
                    <v-jsoneditor v-if="script" :value="script" :options="options" :plus="true" :height="'640px'"
                        @error="onError"></v-jsoneditor>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import { Api } from "../../lib/api";
const api = new Api();
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import VJsoneditor from 'v-jsoneditor/src/index';
import clipboardbutton from "./../../components/clipboardbutton.vue";

export default {
    name: 'siimscripteditor',
    components: {
        clipboardbutton,
        VueJsonPretty,
        VJsoneditor
    },
    data() {
        return {
            searchFor: null,
            script: null,
            scriptItems: [],
            msgIds: [],
            options: {
                "mode": "code",
                "search": true,
                onEditable: (path, field, value) => false,
            },
            max: 0,
            progress: null,
        }
    },
    methods: {
        generate() {
            this.searchFor = this.searchFor.replaceAll('\\n','\n');
            this.msgIds = this.searchFor.split('\n').filter(x => x.length > 0);
            this.max = this.msgIds.length;
            this.scriptItems = [];
            this.progress = "Startar...";
            this.addNextScriptItem();
            
        },
        addNextScriptItem() {
            if (this.msgIds.length > 0) {
                this.progress = `Hämtar ${this.scriptItems.length+1} av ${this.max}...`;
                let msgId = this.msgIds[0].split(' ')[0];
                api.get('/api/apimessages/' + msgId).then(res => {
                    var x = this.msgIds[0];
                    this.scriptItems.push({
                        name: res.data.MsgRefId,
                        msgtype: res.data.MsgType,
                        msg: JSON.parse(res.data.Msg),
                        received: res.data.Received,
                    });
                    this.msgIds.shift();
                    setTimeout(this.addNextScriptItem, 100);
                });
            } else {                
                let scriptObj = {
                    name: 'script',
                    comment: this.searchFor,
                    steps: this.scriptItems
                        .sort((a, b) => a.received < b.received ? -1 : 1)
                };
                this.script = scriptObj; 
                this.progress = "Klar!";
            }
        }
    }
}
</script>